import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Finding, FindingOwner } from './audit.model';
import { TableData, RequestResult } from '../shared/shared.model';
import { API_URL } from '../app.constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FindingService {
  constructor(private http: HttpClient) { }

  getFindingList(auditId: number = 0, page: number = 0, pageSize: number = 10, searchKeyword = ''): Observable<TableData<Finding>> {
    let auditIdUrl = '';
    if (auditId > 0) {
      auditIdUrl = `/byAudit/${auditId}`;
    }

    return this.http.get<TableData<Finding>>(`${API_URL}/Findings${auditIdUrl}`, {
      params: {
        SearchKeyword: searchKeyword,
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<Finding>) => {
        res.page--;

        return res;
      })
    );
  }
  getFinding(findingId: number, auditId: number=0): Observable<Finding> {
    if (auditId > 0) {
      return this.http.get<Finding>(`${API_URL}/Findings/byAudit/${auditId}/${findingId}`);
    }

    return this.http.get<Finding>(`${API_URL}/Findings/${findingId}`);
  }

  getFindingOwners(): Observable<Array<FindingOwner>> {
    return this.http.get<Array<FindingOwner>>(`${API_URL}/FindingOwners`);
  }

  submitFinding(finding: Finding): Observable<number> {
    return this.http.post<number>(`${API_URL}/Findings`, finding);
  }

  updateFinding(finding: Finding): Observable<Finding> {
    return this.http.patch<Finding>(`${API_URL}/Findings/${finding.id}`, finding);
  }

  deleteFinding(id: number): Observable<RequestResult> {
    return this.http.delete<RequestResult>(`${API_URL}/Findings/${id}`);
  }
  checkFindingExistence(auditId: number, name: string): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/Findings/exists/${auditId}/${encodeURI(name)}`);
  }
  markAsReady(findingId: number): Observable<boolean> {
    return this.http.post<boolean>(`${API_URL}/Findings/${findingId}/markReady`, undefined);
  }
}
